import React from 'react';
import { FormLabel, FormGroup, Button, ButtonToolbar, FormCheck, Tabs, Tab, Card, Col, Row, InputGroup } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import moment from 'moment';
import { Formik, Form, Field, FieldArray } from 'formik';
import { isNullOrUndefined } from '../../../node_modules/util';
import {
    DATE_FORMAT, DATE_TIME_FORMAT, ADDRESS_INFORMATION, SUBSCRIPTION_DETAILS, DEFAULT_STORE_ID, ADTYPE_REDEEM, ADTYPE_EVENT, ADTYPE_ID,
    REDEMPTION_LIMIT, ADS_PRICE, ISPRIMARY_USER, SUBSCRIPTION_DATE, MEMBERS, EMPTY_STRING, NA, USER_TYPE_2, CALENDAR_MODEL, ADMIN_RIGHTS, MONTHYEAR_DATEPICKER,
    DAYS, START_DATE, END_DATE, TIMEFORMAT_TEMPLATE, DATE_TIMEFORMAT_TEMPLATE, POLLS, INDUSTRY_ID, POLLTYPE_ID, EMPTY, ADDRESS1, EMAIL_ADDRESS, SUPER_ADMIN_RIGHTS, ADTYPE_DONATION,
    STORE_CODE

} from '../../utils/constants';
import { Editor } from 'react-draft-wysiwyg';
import draftToHtml from 'draftjs-to-html';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import { convertToRaw } from 'draft-js';
import { FaCalendarAlt } from 'react-icons/fa';
import { MSG_REDEEM_GUIDE, ALLOW_REDEMPTION } from '../../utils/messages';
import HeaderComponent from './HeaderComponent';
import NumberFormat from 'react-number-format';
import { isStringEmptyOrNull } from '../../utils/common';

let FormTemplate = (props) => {

    //Initial values
    let initialValues = props.initialValues;


    const requiredInputClass = "required-input";
    const defaultClass = "form-input";

    if (isNullOrUndefined(props.initialValues)) {
        initialValues = {};
        //Initial value if tabbed or single
        if (isNullOrUndefined(props.initialValues)) {
            if (props.tabbed || props.nested) {
                props.multiFormInputs.map(tab => {
                    let modelValues = {};
                    tab.form.map(input => (
                        "datepicker" === input.type ? modelValues[input.name] = moment()
                            : modelValues[input.name] = input.default
                    ));
                    initialValues[tab.model] = modelValues;
                    return initialValues[tab.model];
                });
            } else {
                let modelValues = {};
                props.formInputs.form.map(input =>
                    "datepicker" === input.type ? modelValues[input.name] = moment()
                        : "dateRange" === input.type ? (
                            modelValues["startDate"] = moment().format(DATE_FORMAT),
                            modelValues["endDate"] = moment().add('1', DAYS).format(DATE_FORMAT)
                        ) : "dateTimeRange" === input.type ? (
                            modelValues["startDate"] = moment().format(DATE_TIME_FORMAT),
                            modelValues["endDate"] = moment().add('1', DAYS).format(DATE_TIME_FORMAT)
                        ) : modelValues[input.name] = input.default

                )
                initialValues[props.formInputs.model] = modelValues;
            }
        }
    }

    function RenderInput(values, model, input, fieldValue, setFieldValue, errors, touched) {
        let modelField = `${model}.${input.name}`;
        let modelTouch = touched[model];
        let isTouched = undefined !== touched[model] && modelTouch[input.name];
        let isError = undefined !== errors[modelField];
        let displayError = isTouched && isError;
        let adsTypeClassName = (ADTYPE_ID === input.name && DEFAULT_STORE_ID !== Number(props.storeId)) ? "hidden" : "";
        let redeemClassName = (REDEMPTION_LIMIT === input.name && DEFAULT_STORE_ID === Number(props.storeId) && Number(values[model][ADTYPE_ID]) === ADTYPE_DONATION) ? "hidden" : "";
        let adsPriceClassName = (ADS_PRICE === input.name && DEFAULT_STORE_ID === Number(props.storeId) && Number(values[model][ADTYPE_ID]) === ADTYPE_EVENT) ? "visible" : "hidden"

        switch (input.type) {
            //render wysiwyg editor
            case "editor": {
                return (
                    <Col
                        key={modelField}
                        md={isNullOrUndefined(input.md) ? 12 : input.md}
                        xs={isNullOrUndefined(input.xs) ? 12 : input.xs}
                    >
                        <FormGroup key={input.name} className={defaultClass}>
                            <FormLabel className={input.required && requiredInputClass}>{input.label}</FormLabel>
                            <Card className={displayError ? "form-error" : ""} key={input.name} style={{ margin: 0 }}>
                                <Editor
                                    toolbar={{
                                        options: ['inline', 'fontSize', 'fontFamily', 'list', 'textAlign', 'colorPicker', 'remove', 'history']
                                    }}
                                    handlePastedText={() => false}
                                    editorState={props.editorState} //required
                                    toolbarClassName={props.readOnly ? "toolbarHiddenClassName" : "toolbarClassName"}
                                    readOnly={props.readOnly}
                                    wrapperClassName="wrapperClassName"
                                    editorClassName="editorClassName"
                                    style={{}}
                                    ref={props.editorRef}
                                    onEditorStateChange={(editorState) => {
                                        let rawHTML = draftToHtml(convertToRaw(editorState.getCurrentContent()));
                                        setFieldValue(modelField, rawHTML)
                                        props.updateEditorState(editorState) //required on component
                                    }}
                                />
                            </Card>
                            {CustomError(errors[modelField], displayError)}
                        </FormGroup>
                    </Col>
                );
            }

            //render wysiwyg editor
            case "editor_two": {
                return (
                    <Col
                        key={modelField}
                        md={isNullOrUndefined(input.md) ? 12 : input.md}
                        xs={isNullOrUndefined(input.xs) ? 12 : input.xs}
                    >
                        <FormGroup key={input.name} className={defaultClass}>
                            <FormLabel className={input.required && requiredInputClass}>{input.label}</FormLabel>
                            <Card className={displayError ? "form-error" : ""} key={input.name} style={{ margin: 0 }}>
                                <Editor
                                    toolbar={{
                                        options: ['inline', 'fontSize', 'fontFamily', 'list', 'textAlign', 'colorPicker', 'remove', 'history']
                                    }}
                                    editorState={props.editorStateTwo} //required
                                    toolbarClassName={props.readOnly ? "toolbarHiddenClassName" : "toolbarClassName"}
                                    readOnly={props.readOnly}
                                    wrapperClassName="wrapperClassName"
                                    editorClassName="editorClassName"
                                    style={{}}
                                    onEditorStateChange={(editorStateTwo) => {
                                        let rawHTML = draftToHtml(convertToRaw(editorStateTwo.getCurrentContent()));
                                        setFieldValue(modelField, rawHTML)
                                        props.updateEditorStateTwo(editorStateTwo) //required on component
                                    }}
                                />
                            </Card>
                            {CustomError(errors[modelField], displayError)}
                        </FormGroup>
                    </Col>
                );
            }

            //renders file upload
            case "file": {
                return (
                    <FormGroup key={input.name} className={defaultClass}>
                        <FormLabel className={input.required && requiredInputClass} >{input.label}</FormLabel>
                        <br />
                        <input name={modelField} type="file" onChange={(event) => {
                            setFieldValue(modelField, event.target.files[0]);
                        }} />
                    </FormGroup>
                );
            }

            //renders radio button group field
            case "radio": {
                return (
                    <React.Fragment key={modelField}>
                        <Col
                            md={isNullOrUndefined(input.md) ? 12 : input.md}
                            xs={isNullOrUndefined(input.xs) ? 12 : input.xs}
                        >
                            <FormGroup key={input.name} className={defaultClass}>
                                <FormLabel className={input.required && requiredInputClass} >{input.label}</FormLabel >
                                {input.inline && <br />}

                                {props.radioInput.map((radio, index) => {
                                    if (radio.name === input.name) {
                                        return (
                                            <FormCheck
                                                id={input.name + index}
                                                type="radio"
                                                inline={input.inline}
                                                key={index}
                                                value={radio.value}
                                                disabled={props.readOnly}
                                                name={modelField}
                                                onChange={event => setFieldValue(modelField, event.target.value)}
                                                checked={!isNullOrUndefined(fieldValue) && fieldValue.toString() === radio.value.toString()}
                                                label={radio.label}
                                            />
                                        );
                                    }

                                    return null;
                                })}
                                {CustomError(errors[modelField], displayError)}
                            </FormGroup>
                        </Col>
                    </React.Fragment>
                )
            }


            //renders single checkbox field
            case "checkbox": {
                return (
                    <React.Fragment key={modelField}>
                        <Col
                            md={isNullOrUndefined(input.md) ? 12 : input.md}
                            xs={isNullOrUndefined(input.xs) ? 12 : input.xs}
                            className={ISPRIMARY_USER === input.name && 'primary-checkbox'}
                        >
                            <FormGroup key={input.name} className={defaultClass}>
                                <FormLabel className={input.required && requiredInputClass} ></FormLabel >

                                <FormCheck
                                    id={input.name + fieldValue}
                                    type="checkbox"
                                    value={fieldValue}
                                    name={modelField}
                                    disabled={props.readOnly}
                                    onChange={() => {

                                        if (SUPER_ADMIN_RIGHTS === input.name && !fieldValue) {
                                            setFieldValue(`${model}.${ADMIN_RIGHTS}`, false)
                                        }
                                        else if (ADMIN_RIGHTS === input.name && !fieldValue) {
                                            setFieldValue(`${model}.${SUPER_ADMIN_RIGHTS}`, false)
                                        }
                                        setFieldValue(modelField, !fieldValue)


                                    }}
                                    checked={CALENDAR_MODEL === model ? Number(fieldValue) : fieldValue}
                                    label={input.label}
                                    className={!isNullOrUndefined(props.userType) && (ADMIN_RIGHTS === input.name || SUPER_ADMIN_RIGHTS === input.name) && USER_TYPE_2 !== props.userType ? "hidden" : "visible"}

                                />
                                {CustomError(errors[modelField], displayError)}
                            </FormGroup>
                        </Col>
                    </React.Fragment>
                )
            }

            //renders multiple checkbox field
            case "multi-checkbox": {
                return (
                    <FormGroup key={input.name} className={defaultClass}>
                        <FormLabel className={input.required && requiredInputClass} >{input.label}</FormLabel >

                        <FieldArray
                            name={modelField}
                            render={arrayHelpers => (
                                <div>
                                    {props.checkboxInput.map((checkbox, index) => {
                                        if (input.name === checkbox.name) {
                                            return (
                                                <FormCheck
                                                    id={input.name + index}
                                                    type="checkbox"
                                                    key={index}
                                                    name={modelField}
                                                    value={checkbox.value}
                                                    inline={input.inline}
                                                    checked={0 <= fieldValue.indexOf(checkbox.value)}
                                                    onChange={event => {
                                                        if (event.target.checked) {
                                                            arrayHelpers.push(checkbox.value)
                                                        } else {
                                                            let checkIndex = fieldValue.indexOf(checkbox.value);
                                                            arrayHelpers.remove(checkIndex);
                                                        }
                                                    }}
                                                    label={checkbox.label}
                                                />
                                            )
                                        }

                                        return null;
                                    })}
                                </div>
                            )}
                        />
                        {CustomError(errors[modelField], displayError)}
                    </FormGroup>
                )
            }

            //renders datepicker field
            case "datepicker": {


                let dateValue = moment(fieldValue, input.format).isValid() ? moment(fieldValue, input.format) : moment();

                let values = props.initialValues && !isNullOrUndefined(props.initialValues.RenewalModel) && props.initialValues.RenewalModel.subscriptionEndDate

                return (
                    <React.Fragment key={modelField}>
                        <Col
                            md={isNullOrUndefined(input.md) ? 12 : input.md}
                            xs={isNullOrUndefined(input.xs) ? 12 : input.xs}
                        >
                            <FormGroup key={input.name} className={defaultClass}>
                                <FormLabel className={input.required && requiredInputClass} >{input.label}</FormLabel >

                                <div className="datetime-div">
                                    <label className="click-calendar">
                                        <DatePicker
                                            className={displayError ? "form-error" : "date"}
                                            name={modelField}
                                            disabled={props.readOnly}
                                            selected={dateValue.toDate()}
                                            onChangeRaw={(event) => event.preventDefault()}
                                            onChange={newValue => setFieldValue(modelField, moment(newValue).format(DATE_FORMAT))}
                                            placeholderText={input.placeholder}
                                            peekNextMonth
                                            value={dateValue.toDate()}
                                            showMonthDropdown
                                            showYearDropdown
                                            dropdownMode="select"
                                            minDate={"subscriptionEndDate" === input.name ? (EMPTY_STRING === values || moment().isAfter(values)) ? moment(moment().format(DATE_FORMAT)).toDate() : moment(moment(values).format(DATE_FORMAT)).toDate() : false}
                                        />

                                        {!props.readOnly && <FaCalendarAlt className="calendar" />}
                                    </label>
                                </div>
                                {CustomError(errors[modelField], displayError)}
                            </FormGroup>
                        </Col>
                    </React.Fragment>
                );
            }

            //renders monthYearDatepicker field
            case "monthYearDatepicker": {
                return (
                    <React.Fragment key={modelField}>
                        <Col
                            md={isNullOrUndefined(input.md) ? 12 : input.md}
                            xs={isNullOrUndefined(input.xs) ? 12 : input.xs}
                        >
                            <FormGroup key={input.name} className={defaultClass}>
                                <FormLabel className={input.required && requiredInputClass} >{input.label}</FormLabel >

                                <div className="datetime-div">
                                    <DatePicker
                                        selected={fieldValue}
                                        className="datepicker"
                                        onChange={date => setFieldValue(modelField, date)}
                                        name={modelField}
                                        dateFormat={MONTHYEAR_DATEPICKER}
                                        showMonthYearPicker
                                        onChangeRaw={(e) => { e.preventDefault() }}
                                    />
                                </div>
                                {CustomError(errors[modelField], displayError)}
                            </FormGroup>
                        </Col>
                    </React.Fragment>
                );
            }

            //renders date range datepicker fields
            case "dateRange": {

                let startField = `${model}.startDate`;
                let endField = `${model}.endDate`;
                let startDateValue = values[model].startDate;
                let endDateValue = values[model].endDate;

                return (

                    <React.Fragment key={modelField}>
                        {SUBSCRIPTION_DATE === input.name &&
                            <div className="address-div">
                                <HeaderComponent
                                    headerName={SUBSCRIPTION_DETAILS}
                                    headerClass={'address-hr'}
                                />
                            </div>
                        }
                        <Col
                            key={"daterange"}
                            md={isNullOrUndefined(input.md) ? 12 : input.md}
                            xs={isNullOrUndefined(input.xs) ? 12 : input.xs}
                        >
                            <Row className="row-date">
                                <div>
                                    <FormGroup className={defaultClass} style={{ width: 250, paddingLeft: 16 }}>
                                        <FormLabel className={input.required && requiredInputClass} >{START_DATE}</FormLabel >
                                        <div className="datetime-div">
                                            <label className="click-calendar">
                                                <DatePicker
                                                    className={displayError ? "form-error daterange" : "daterange"}
                                                    name={startField}
                                                    selected={moment(startDateValue).isValid() && moment(startDateValue).toDate()}
                                                    value={MEMBERS !== props.formName ? startDateValue : !isNullOrUndefined(props.initialValues) ? (EMPTY_STRING !== props.initialValues.MemberModel.subscriptionStartDate) ? moment(props.initialValues.MemberModel.subscriptionStartDate).format(DATE_FORMAT) : NA : startDateValue}
                                                    disabled={props.readOnly || (SUBSCRIPTION_DATE === input.name && props.editMode)}
                                                    peekNextMonth
                                                    showMonthDropdown
                                                    showYearDropdown
                                                    dropdownMode="select"
                                                    onChangeRaw={(event) => event.preventDefault()}
                                                    onChange={newValue => {
                                                        if (moment(endDateValue).isBefore(newValue)) {
                                                            setFieldValue(endField, moment(newValue).add(1, DAYS).format(DATE_FORMAT))
                                                        }
                                                        setFieldValue(startField, moment(newValue).format(DATE_FORMAT))
                                                    }}
                                                />
                                                {!props.readOnly && <FaCalendarAlt className="calendar" />}
                                            </label>
                                        </div>
                                    </FormGroup>
                                    {CustomError(errors[startField], displayError)}
                                </div>
                                <div>
                                    <FormGroup className={defaultClass} style={{ width: 250, paddingLeft: 16 }}>
                                        <FormLabel className={input.required && requiredInputClass} >{END_DATE}</FormLabel >
                                        <div className="datetime-div">
                                            <label className="click-calendar">
                                                <DatePicker
                                                    className={displayError ? "form-error daterange datetime" : "daterange datetime"}
                                                    name={endField}
                                                    selected={moment(endDateValue).isValid() && moment(endDateValue).toDate()}
                                                    value={MEMBERS !== props.formName ? endDateValue : !isNullOrUndefined(props.initialValues) ? (EMPTY_STRING !== props.initialValues.MemberModel.subscriptionEndDate) ? moment(props.initialValues.MemberModel.subscriptionEndDate).format(DATE_FORMAT) : NA : endDateValue}
                                                    peekNextMonth
                                                    disabled={props.readOnly || (SUBSCRIPTION_DATE === input.name && props.editMode)}
                                                    showMonthDropdown
                                                    showYearDropdown
                                                    dropdownMode="select"
                                                    minDate={moment(moment(startDateValue).format(DATE_FORMAT)).toDate()}
                                                    onChangeRaw={(event) => event.preventDefault()}
                                                    onChange={newValue => setFieldValue(endField, moment(newValue).format(DATE_FORMAT))}
                                                />
                                                {!props.readOnly && <FaCalendarAlt className="calendar" />}
                                            </label>
                                        </div>
                                    </FormGroup>
                                    {CustomError(errors[endField], displayError)}
                                </div>
                            </Row>
                        </Col>
                    </React.Fragment>
                );
            }

            case "yearpicker": {

                let dateValue = moment(fieldValue, input.format).isValid() ? moment(fieldValue, input.format) : null;

                return (
                    <React.Fragment key={modelField}>
                        <Col
                            md={isNullOrUndefined(input.md) ? 12 : input.md}
                            xs={isNullOrUndefined(input.xs) ? 12 : input.xs}
                        >
                            <FormGroup key={input.name} className={defaultClass}>
                                <FormLabel className={input.required && requiredInputClass} >{input.label}</FormLabel >

                                <div className="datetime-div">
                                    <label className="click-calendar">
                                        <DatePicker
                                            disabled={props.readOnly}
                                            className={displayError ? "form-error" : "date"}
                                            name={modelField}
                                            selected={isNullOrUndefined(dateValue) ? moment().toDate() : dateValue.toDate()}
                                            onChange={newValue => {
                                                setFieldValue(modelField, newValue)
                                            }}
                                            onChangeRaw={(event) => event.preventDefault()}
                                            dateFormat="yyyy"
                                            showMonthYearPicker
                                        />
                                        {!props.readOnly && <FaCalendarAlt className="calendar" />}
                                    </label>
                                </div>
                                {CustomError(errors[modelField], displayError)}
                            </FormGroup>
                        </Col>
                    </React.Fragment>
                );
            }

            case "line": {
                return (
                    <div key={modelField} style={{ marginTop: 24, marginBottom: 24 }}>
                        <hr style={{ borderTop: "1px solid rgba(0,0,0,0.3)" }} />
                    </div>
                )
            }

            //renders date range datepicker fields
            case "dateTimeRange": {
                let startField = `${model}.startDate`;
                let endField = `${model}.endDate`;
                let startDateValue = values[model].startDate;
                let endDateValue = values[model].endDate;

                return (
                    <React.Fragment key={modelField}>
                        <Col
                            key={"daterange"}
                            md={isNullOrUndefined(input.md) ? 12 : input.md}
                            xs={isNullOrUndefined(input.xs) ? 12 : input.xs}
                        >
                            <Row className="row-date">
                                <div>
                                    <FormGroup className={defaultClass} style={{ width: 250, paddingLeft: 16, paddingBottom: 10 }}>
                                        <FormLabel className={input.required && requiredInputClass} >{START_DATE}</FormLabel >

                                        <div className="datetime-div">
                                            <label className="click-calendar">
                                                <DatePicker
                                                    peekNextMonth
                                                    showMonthDropdown
                                                    showYearDropdown
                                                    dropdownMode="select"
                                                    className={displayError ? "form-error daterange" : "daterange"}
                                                    name={startField}
                                                    selected={moment(startDateValue).toDate()}
                                                    value={moment(startDateValue).format(DATE_TIME_FORMAT)}
                                                    disabled={props.readOnly}
                                                    showTimeSelect
                                                    timeFormat={TIMEFORMAT_TEMPLATE}
                                                    timeIntervals={15}
                                                    timeCaption="time"
                                                    dateFormat={DATE_TIMEFORMAT_TEMPLATE}
                                                    minDate={moment(moment().format(DATE_TIME_FORMAT)).toDate()}
                                                    onChangeRaw={(event) => event.preventDefault()}
                                                    onChange={newValue => {
                                                        if (moment(endDateValue).isBefore(newValue)) {
                                                            setFieldValue(endField, moment(newValue).add(1, DAYS).format(DATE_TIME_FORMAT))
                                                        }
                                                        setFieldValue(startField, moment(newValue).format(DATE_TIME_FORMAT))
                                                    }}
                                                />
                                                {!props.readOnly && <FaCalendarAlt className="calendar" />}
                                            </label>
                                        </div>
                                        {CustomError(errors[startField], displayError)}
                                    </FormGroup>

                                </div>

                                <div>
                                    <FormGroup className={defaultClass} style={{ width: 250, paddingLeft: 16, paddingBottom: 10 }}>
                                        <FormLabel className={input.required && requiredInputClass} >{END_DATE}</FormLabel >

                                        <div className="datetime-div">
                                            <label className="click-calendar">
                                                <DatePicker
                                                    peekNextMonth
                                                    showMonthDropdown
                                                    showYearDropdown
                                                    dropdownMode="select"
                                                    className={displayError ? "form-error daterange datetime" : " daterange datetime"}
                                                    name={endField}
                                                    disabled={props.readOnly}
                                                    selected={moment(endDateValue).toDate()}
                                                    value={moment(endDateValue).format(DATE_TIME_FORMAT)}
                                                    showTimeSelect
                                                    timeFormat={TIMEFORMAT_TEMPLATE}
                                                    timeIntervals={15}
                                                    timeCaption="time"
                                                    dateFormat={DATE_TIMEFORMAT_TEMPLATE}
                                                    minDate={moment(moment(startDateValue).format(DATE_TIME_FORMAT)).toDate()}
                                                    onChangeRaw={(event) => event.preventDefault()}
                                                    onChange={newValue => setFieldValue(endField, moment(newValue).format(DATE_TIME_FORMAT))}
                                                />
                                                {!props.readOnly && <FaCalendarAlt className="calendar" />}
                                            </label>
                                        </div>
                                        {CustomError(errors[endField], props.hasSubmit)}
                                    </FormGroup>
                                </div>
                            </Row>
                        </Col>
                    </React.Fragment>
                );
            }

            // renders select field
            case "select": {
                
                return (
                    <Col
                        key={modelField}
                        md={isNullOrUndefined(input.md) ? 12 : input.md}
                        xs={isNullOrUndefined(input.xs) ? 12 : input.xs}
                        className={adsTypeClassName}
                    >
                        <FormGroup key={input.name} className={defaultClass}>
                            <FormLabel className={input.required && requiredInputClass} >{input.label}</FormLabel >

                            {(props.readOnly || (props.editMode && POLLS === props.formName)) ? (
                                <p style={{ marginLeft: 16 }}>
                                    {MEMBERS === props.formName && INDUSTRY_ID === input.name
                                        ? (props.selectInputIndustry && props.selectInputIndustry.map((data) => {
                                            let name = EMPTY_STRING;
                                            if (Number(fieldValue) === Number(data.industryId)) {
                                                name = data.industryName
                                            }
                                            return name;
                                        }))
                                        : (props.selectInput && props.selectInput.map((value) => {
                                            let val = EMPTY_STRING;
                                            if ((input.name === value.name) && (Number(fieldValue) === Number(value.value))) {
                                                val = value.label
                                            }
                                            return val;
                                        }))}
                                </p>
                            ) : (
                                    <Field
                                        className={displayError ? "form-control form-error" : "form-control"}
                                        component="select"
                                        name={modelField}
                                        onChange={event => setFieldValue(modelField, event.target.value)}
                                        disabled={props.isDisabled}
                                    >
                                        
                                        <option disabled value={EMPTY_STRING}>{input.placeholder}</option>
                                        {POLLTYPE_ID === input.name ?

                                            props.selectInput && props.selectInput.filter((option) => option.name === input.name).map((item, i) => {
                                                return (
                                                    <option key={i} value={item.value}> {item.label} </option>
                                                );
                                            })
                                            :
                                            INDUSTRY_ID === input.name ?
                                                props.selectInputIndustry && props.selectInputIndustry.map((item, i) => {
                                                    return (
                                                        <option key={i} value={Number(item.industryId)}> {item.industryName} </option>
                                                    );
                                                })
                                                :

                                                props.selectInput && props.selectInput.map((item, i) => {
                                                    return (
                                                        <option key={i} value={item.value}> {MEMBERS === props.formName ? item.value : item.label} </option>
                                                    );
                                                })
                                        }

                                    </Field>
                                )}
                            {CustomError(errors[modelField], displayError)}
                        </FormGroup>
                    </Col>
                );
            }

            case "price": {
                return (
                    <Col
                        key={modelField}
                        md={isNullOrUndefined(input.md) ? 12 : input.md}
                        xs={isNullOrUndefined(input.xs) ? 12 : input.xs}
                    >
                        <FormGroup className={defaultClass}>
                            <FormLabel className={input.required && requiredInputClass} >{input.label}</FormLabel >

                            <InputGroup>
                                {props.readOnly ? (
                                    <p style={{ marginLeft: 16 }}>&#x20B1;{parseFloat(fieldValue).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</p>
                                ) : (
                                        <React.Fragment>
                                            <InputGroup.Prepend>
                                                <InputGroup.Text id="basic-addon1">&#x20B1;</InputGroup.Text>
                                            </InputGroup.Prepend>

                                            <NumberFormat
                                                className={displayError ? "form-control form-error price" : "form-control price"}
                                                thousandSeparator={true}
                                                placeholder={input.placeholder}
                                                fixedDecimalScale={true}
                                                decimalSeparator={'.'}
                                                defaultValue={0.00 < fieldValue ? fieldValue : 0.00}
                                                decimalScale={2}
                                                min={input.min}
                                                max={input.max}
                                                allowNegative={false}
                                                onValueChange={value => {
                                                    setFieldValue(modelField, value)
                                                }
                                                }

                                            />
                                        </React.Fragment>
                                    )}
                            </InputGroup>
                            {CustomError(errors[modelField], props.hasSubmit)}
                        </FormGroup>
                    </Col>
                )
            }

            case "redemption": {
                return (
                    <React.Fragment key={modelField}>
                        <Col
                            md={isNullOrUndefined(input.md) ? 12 : input.md}
                            xs={isNullOrUndefined(input.xs) ? 12 : input.xs}
                            className={redeemClassName}
                        >
                            <FormGroup className={EMPTY === input.name ? "hidden" : defaultClass}>
                                <FormLabel className={input.required && requiredInputClass} >
                                    {Number(values[model][ADTYPE_ID]) === ADTYPE_REDEEM ? input.label : "Ticket Limit"}
                                </FormLabel >

                                <Field
                                    className={displayError ? "form-control form-error" : "form-control"}
                                    placeholder={input.placeholder}
                                    component={input.component}
                                    readOnly={props.readOnly}
                                    autoComplete={"off"}
                                    disabled={props.readOnly}
                                    type={"number"}
                                    name={modelField}
                                    maxLength={input.maxLength}
                                    minLength={input.minLength}
                                    min={input.min}
                                    max={input.max}
                                    onChange={event => { setFieldValue(modelField, event.target.value) }}
                                />
                                {CustomError(errors[modelField], displayError)}
                            </FormGroup>
                        </Col>
                        {(REDEMPTION_LIMIT === input.name && Number(values[model][ADTYPE_ID]) === ADTYPE_REDEEM) && (
                            <Col md={6} style={{ marginTop: 32 }} className={redeemClassName}>
                                <p className={"label-guide " + redeemClassName}>{MSG_REDEEM_GUIDE}</p>
                            </Col>
                        )}
                        {/* </Row> */}
                    </React.Fragment>
                )
            }

            case "adsPrice": {
                return (
                    <React.Fragment key={modelField}>
                        <Col
                            md={isNullOrUndefined(input.md) ? 12 : input.md}
                            xs={isNullOrUndefined(input.xs) ? 12 : input.xs}
                            className={adsPriceClassName}
                        >
                            <FormGroup className={EMPTY === input.name ? "hidden" : defaultClass}>
                                <FormLabel className={input.required && requiredInputClass} >{input.label}</FormLabel >

                                <InputGroup>
                                    {props.readOnly ? (
                                        <p style={{ marginLeft: 16 }}>&#x20B1;{parseFloat(fieldValue).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</p>
                                    ) : (
                                            <React.Fragment>
                                                <InputGroup.Prepend>
                                                    <InputGroup.Text id="basic-addon1">&#x20B1;</InputGroup.Text>
                                                </InputGroup.Prepend>
                                                <NumberFormat
                                                    className={displayError ? "form-control form-error price" : "form-control price"}
                                                    thousandSeparator={true}
                                                    placeholder={input.placeholder}
                                                    fixedDecimalScale={true}
                                                    decimalSeparator={'.'}
                                                    defaultValue={0.00 < fieldValue ? fieldValue : 0.00}
                                                    decimalScale={2}
                                                    min={input.min}
                                                    max={input.max}
                                                    allowNegative={false}
                                                    onValueChange={value => {
                                                        setFieldValue(modelField, value)
                                                    }
                                                    }

                                                />
                                            </React.Fragment>
                                        )}
                                </InputGroup>
                                {CustomError(errors[modelField], displayError)}
                            </FormGroup>
                        </Col>
                        {/* </Row> */}
                    </React.Fragment>
                )
            }

            //renders text, textarea, email, password, numbers, default input
            default: {
                return (
                    <React.Fragment key={modelField}>
                        {ADDRESS1 === input.name &&
                            <div className="address-div">
                                <HeaderComponent
                                    headerName={ADDRESS_INFORMATION}
                                    headerClass={'address-hr'}
                                />
                            </div>
                        }
                        <Col
                            md={isNullOrUndefined(input.md) ? 12 : input.md}
                            xs={isNullOrUndefined(input.xs) ? 12 : input.xs}
                            className={redeemClassName}
                        >
                            <FormGroup className={EMPTY === input.name ? "hidden" : defaultClass}>
                                <FormLabel className={input.required && requiredInputClass} >{input.label} </FormLabel >
                                {(STORE_CODE === input.name) && (
                                    <p className={"code-guide" + redeemClassName}>{ALLOW_REDEMPTION}</p>
                                )}
                                <Field
                                    className={displayError ? "form-control form-error" : "form-control"}
                                    placeholder={props.readOnly ? "" : input.placeholder}
                                    component={input.component}
                                    readOnly={props.readOnly}
                                    autoComplete={"off"}
                                    disabled={props.readOnly || (EMAIL_ADDRESS === input.name && props.editMode)}
                                    type={input.type}
                                    name={modelField}
                                    maxLength={input.maxLength}
                                    minLength={input.minLength}
                                    min={input.min}
                                    max={input.max}
                                    onChange={event => {
                                        if (0 <= ["storeUsername", "storePassword"].indexOf(input.name)) {
                                            setFieldValue(modelField, event.target.value.trim())
                                        } else {
                                            setFieldValue(modelField, event.target.value)
                                        }

                                    }}
                                />
                                {CustomError(errors[modelField], displayError)}
                            </FormGroup>
                        </Col>

                    </React.Fragment>
                );
            }
        }

    }


    //Error messages
    const CustomError = (error, displayError) => {
        return displayError && !isStringEmptyOrNull(error) ? <p className="formik-error">{error}</p> : null;
    }

    //Renders form buttons
    const FormButtons = props.formButtons && props.formButtons.map((button, i) => {
        return (
            <Button type={button.submit ? "submit" : "button"} key={i} className={button.className} variant={button.variant} size={button.size} onClick={button.onClick}>
                {button.label}
            </Button>
        );
    });

    //Maps form inputs
    const FormInputs = (values, setFieldValue, errors, touched) => props.formInputs.form && props.formInputs.form.map((input) => {
        return RenderInput(values, props.formInputs.model, input, values[props.formInputs.model][input.name], setFieldValue, errors, touched)
    });

    //Maps form inputs
    const NestedInputs = (model, values, setFieldValue, errors, touched) => model.form && model.form.map((input) => {
        return RenderInput(model.model, input, values[model.model][input.name], setFieldValue, errors, touched)
    });

    //Tabbed Form Render
    const RenderTabForm = (values, setFieldValue, errors, touched) => {
        return (
            <Tabs>
                {props.multiFormInputs.map((model, index) => {
                    return (
                        <Tab key={index} eventKey={index} title={model.label}>
                            <br />
                            {NestedInputs(model, values, setFieldValue, errors, touched)}
                        </Tab>

                    )
                })
                }
            </Tabs>
        );
    }

    //Nested Model Forms Render
    const RenderNestedForm = (values, setFieldValue, errors, touched) => {
        return (
            props.multiFormInputs.map((model, index) => {
                return (
                    <Card key={index}>
                        <h4>{model.label}</h4>
                        {NestedInputs(model, values, setFieldValue, errors, touched)}
                        <h6>{`Model: ${model.model}`}</h6>
                    </Card>);
            })
        );
    }

    if ((!isNullOrUndefined(props.initialValues) && props.editMode) || !props.editMode) {
        const { bindSubmitFormik } = props;
        return (
            <Formik
                ref={node => (!isNullOrUndefined(props.updateFormRef) && props.updateFormRef(node))}
                initialValues={initialValues}
                className={props.className}
                validate={values => {
                    return props.validate(values);
                }}
                onSubmit={(values) => {
                    props.handleSubmit(values)
                }}
            >
                {({ values, setFieldValue, errors, touched, submitForm, resetForm }) => (
                    <Form style={{ width: '100%' }} className={!isNullOrUndefined(props.formClassName) ? props.formClassName : ""}>
                        {props.additionalField && props.additionalField}
                        {!isNullOrUndefined(bindSubmitFormik) && bindSubmitFormik(submitForm, resetForm)}
                        {props.tabbed ? RenderTabForm(values, setFieldValue, errors, touched) :
                            props.nested ? RenderNestedForm(values, setFieldValue, errors, touched) :
                                FormInputs(values, setFieldValue, errors, touched)}

                        {props.formButtons && (
                            <Col style={{ display: 'flex', justifyContent: 'flex-end', borderTop: "1px solid #cacaca", paddingTop: 20 }}>
                                <ButtonToolbar>
                                    {FormButtons}
                                </ButtonToolbar>
                            </Col>
                        )}

                    </Form>
                )}
            </Formik>
        );
    } else {
        return <p>Loading . . .</p>;
    }
}
export default FormTemplate;